import type { FaireProductEntity } from "../../entity_types/product";

export const p_77rdwfs5tf: FaireProductEntity = {
  token: "p_77rdwfs5tf",
  type: "product",
  name: "To-Brew List Sticky Notes",
  brandToken: "b_btb379emrh",
  brandName: "Mel Andrel",
  imageUrl: "https://cdn.faire.com/fastly/ac3a87003f70ecd29d55a45d2a276b50004b6757a5b87e0d4f821477769ad36a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1f70a41453f931f973a36951c4bfab2d61a72ccb55e37c5447c09ef38294b7f0.jpeg",
    "https://cdn.faire.com/fastly/de4ee4db22783a2bcc7ffd91b858aa59b822ca3d8acd02ab758215093114de80.jpeg",
    "https://cdn.faire.com/fastly/4679fbd2926c2930bd3d47b786d4dd8f207fbfe31f44abe91dbe507dc395a55f.jpeg",
    "https://cdn.faire.com/fastly/816c16f9d2e10f3054edbe7f6948ef05800d30b534b006dd203eeb89151eb254.jpeg"
  ],
  priceDollars: 4,
  description: "Serve up reminders, grocery lists, recipes & more on our To-Brew List Sticky Notes. Inspired by the iconic NYC Anthora Cup. Great for getting organized and bookmarking cookbooks or taking notes on the go.\n\nGood to know: \n\n * Stick & restick anywhere. \n * Measures 3in x 3in \n * 100% Recyclable \n\n",
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:33:08.923Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
